import React from 'react'

import img from './../../assets/schoolAjmer.png';
const RmsAjmer = () => {
  return (
    <>
    <div style={{ backgroundImage: `url(${img})`,height: '370px',
width: '100%', backgroundRepeat:"no-repeat", backgroundSize:"cover"}} ></div>
    <div className="container-fluid px-5 mb-3" >
      

      <header className=" mt-3 pt-3">
        <h3>RMS Ajmer</h3>

      </header>
      <div className="section pb-3">
                     
                      <div className="content-container mt-3">
                      <p>
                        Rashtriya Military School Ajmer, with its panoramic view of surrounding hills, spread over 87 acres was founded on 15 Nov 1930 as King George's Royal Indian Military School to take care of education of sons of defence personnel. In 1952, the school was reorganized on public school lines and admissions were made open to the sons of Defence service Officers and Civilians. In 1954, the school became the member of the India Public School Conference (IPSC).The School was renamed Military School in 1966 and its old motto 'Play the Game' was replaced with 'Sheelam Param Bhushanam' which means 'Character is the highest virtue'. On 25 June 2007 the school got its present name 'Rashtriya Military School Ajmer'.
                        The Rashtriya Military School Ajmer, an English medium school affiliated to CBSE, New Delhi is a catagory 'A' establishment run by the Ministry of Defence and is an active member of the IPSC.The school has several of its alumni occupying high positions in the Armed Forces and in other sectors doing stellar support to the motherland.
                    </p>
      
                      </div>
                  </div>
                  </div>
                  </>
  )
}

export default RmsAjmer
